import { tenants } from "../../config/tenants.js";
import type { News } from "../News.js";
import { NewsKind } from "../NewsKind.js";
import { getBlogPath } from "./getBlogPath.js";
import { getCaseStudiesPath } from "./getCaseStudiesPath.js";

export function getNewsDetailPath(news: Pick<News, "locale" | "urlSlug" | "kind">): string {
	const tenant = tenants[news.locale];
	const subpathMap: Record<NewsKind, string> = {
		[NewsKind.Article]: getBlogPath(tenant),
		[NewsKind.OneTimeArticle]: getBlogPath(tenant),
		[NewsKind.CaseStudy]: getCaseStudiesPath(tenant),
		[NewsKind.Comparison]: getBlogPath(tenant),
	};
	return `${subpathMap[news.kind]}/${news.urlSlug}`;
}
